import React from "react";
import { Helmet } from "react-helmet-async";
import { useLang } from "../context/LanguageContext";

const SITE_URL = "https://vytali.ca";
const DEFAULT_IMAGE = "https://vytali.ca/og-image.png";

/**
 * Per-page SEO + Open Graph meta tags.
 *
 * Language is read from the LanguageContext (source of truth) — the optional
 * `lang` prop is only used as an override for special cases.
 */
export const Seo = ({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  lang: langOverride,
  keywords,
  noIndex = false,
}) => {
  const { lang: ctxLang } = useLang();
  const lang = langOverride || ctxLang || "fr";
  const url = `${SITE_URL}${path}`;
  const absoluteImage = image?.startsWith("http") ? image : `${SITE_URL}${image}`;
  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Vytali" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={absoluteImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content={lang === "fr" ? "fr_CA" : lang === "es" ? "es_ES" : "en_CA"} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={absoluteImage} />
    </Helmet>
  );
};
